export default Object.freeze({
  TRANSLATIONS_LIST: 'TRANSLATIONS_LIST',
  UNTRANSLATED: 'UNTRANSLATED',
  TRANSLATION_UPDATE_DATA: 'TRANSLATION_UPDATE_DATA',
  TRANSLATION_UPDATE: 'TRANSLATION_UPDATE',
  TRANSLATION_CREATE: 'TRANSLATION_CREATE',
  TRANSLATION_CREATE_DATA: 'TRANSLATION_CREATE_DATA',
  TRANSLATION_DELETE: 'TRANSLATION_DELETE',
});
